/**
 * 项目全局配置
 */

// API 域名，默认 localhost:8081，可通过环境变量覆盖
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || process.env.VUE_APP_BASE_URL || 'http://localhost:8081';

// 兼容别名
export const BASE_URL = API_BASE_URL;
